'use strict';

var _      = require('underscore');
var $      = require('jquery');
var Core   = require('../core/core.js');
var Throbber = require("../throbber/throbber.js");
var Velocity = require('velocity-animate');

/**
 * Creates a Splash screen on startup
 *
 * @param {String} [options.target=body]
 * @class
 */

class Splashscreen extends Core {

	_defaults() {
		return {
			target: 'body',
            fields: {
                'showOnlyLoadingBar': ""
            }
		};
	}

	constructor(options) {
		super(options);

        //console.log("Splashscreen");


		this.template = `<div class='editor__splashscreen'>
                            <div class='editor__warning__banner__holder'></div>
                            <div class='editor__splashscreen__inner'>
                                <% if(!showOnlyLoadingBar) { %>
                                    <div class='editor__splashscreen__inner__icon'><img src='<%= icon %>'></div>
                                    <div class='editor__splashscreen__inner__title'><%= title %></div>
                                    <div class='editor__splashscreen__inner__description'><%= description %></div>
                                <% } %>
                                <div class='editor__splashscreen__inner__spinner'></div>
                            </div>
                        </div>`;

		super.render();

        // Add throbber
        new Throbber({
            target: $('.editor__splashscreen__inner__spinner', this.$el)
        });

	}

    hide(){
        var self = this;

        Velocity(this.$el, "stop");
        Velocity(this.$el, {
            'opacity': 0
        },{
            duration: 420,
            easing: "easeInOutCubic",
            complete: function(){
                self.$el.remove();
            }
        });
    }

}


module.exports = Splashscreen;
